import common from './common.json';
import nav from './nav.json';
import home from './home.json';
import guidesIndex from './guidesIndex.json';
import homeV2 from './homeV2.json';
import contact from './contact.json';
import legal from './legal.json';
import cookies from './cookies.json';
import meta from './meta.json';
import weddingPhotoSharing from './weddingPhotoSharing.json';
import digitalWeddingInvitation from './digitalWeddingInvitation.json';
import weddingPlanning from './weddingPlanning.json';
import weddingRsvp from './weddingRsvp.json';
import weddingSeating from './weddingSeating.json';

export default {
  ...common,
  ...nav,
  ...home,
  ...guidesIndex,
  ...homeV2,
  ...contact,
  ...legal,
  ...cookies,
  ...meta,
  ...weddingPhotoSharing,
  ...digitalWeddingInvitation,
  ...weddingPlanning,
  ...weddingRsvp,
  ...weddingSeating,
};
